import { create } from "zustand";

interface NavState {
  isMobileNavOpen: boolean;
  setMobileNavOpen: (isMobileNavOpen: boolean) => void;
}

export const useNavStore = create<NavState>((set) => ({
  isMobileNavOpen: false,
  setMobileNavOpen: (isMobileNavOpen) => set({ isMobileNavOpen }),
}));
